import React from "react";
import { DataProductList } from "../data_products/DataProductList"
import useCustomTable from "../tables/useCustomTable";
import { useGetCurrentUserQuery } from "../../api/userApiSlice";

export default function DataVendorStreams({onRowClick, streams, onAdd, newButtonContent}) {
  const {data: {isAdmin: userIsAdmin} = {}, isSuccess} = useGetCurrentUserQuery()
  let columns = [{
    Header: 'Stream',
    accessor: 'stream'
  },{
    Header: 'Name',
    accessor: 'name'
  },{
    Header: 'Data Type',
    accessor: 'data_type'
  },{
    Header: 'Created At',
    accessor: 'created_at',
    format: 'date',
    formatOptions: {dateFormat: "longShortMonth"}
  }]
  if (userIsAdmin) {
    columns = [
      ...(columns.slice(0, -1)),
      {
        Header: 'Api',
        accessor: 'api_environment'
      },
      columns.at(-1)
    ]
  }
  console.log(columns)


  const {
    tableProps,
    paginationProps,
    tableSearchProps
  } = useCustomTable({
    sortable: true,
    paginate: true
  })

  const dataProductListOptions = {
    onRowClick,
    columns,
    tableProps,
    paginationProps,
    tableSearchProps,
    onAdd,
    newButtonContent
  }

  return (
    <DataProductList {...dataProductListOptions} data={streams} />
  )
}
